export default "__VITE_ASSET__BRWBW$P7__"